import api from '../../lib/api';
import { CommunicationMatrixPayload, CommunicationMatrixItem, ListResponse, ListParams } from './types';

export const fetchMatrix = async (params: ListParams = {}): Promise<ListResponse> => {
  const { search = '', page = 1, pageSize = 10, who = '', toWhom = '', sortBy = 'createdAt', sortDir = 'desc' } = params;
  const { data } = await api.get<ListResponse>('communication-matrix', {
    params: { search, page, pageSize, who, toWhom, sortBy, sortDir }
  });
  return data;
};

export const createItem = async (payload: CommunicationMatrixPayload): Promise<CommunicationMatrixItem> => {
  const { data } = await api.post<CommunicationMatrixItem>('communication-matrix', payload);
  return data;
};

export const updateItem = async (id: string, payload: CommunicationMatrixPayload): Promise<CommunicationMatrixItem> => {
  const { data } = await api.put<CommunicationMatrixItem>(`communication-matrix/${id}`, payload);
  return data;
};

export const deleteItem = async (id: string): Promise<void> => {
  await api.delete(`communication-matrix/${id}`);
};

